import request from '@/utils/request'

// 有赞余额流水分页列表
export function getBalanceLogList(params) {
  return request({ url: '/api/balanceLog/list', method: 'get', params })
}

// 导出有赞余额流水（Excel）
export function exportBalanceLogList(params) {
  return request({ url: '/api/balanceLog/export', method: 'get', params, responseType: 'blob' })
}
